// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const confirmed = "StatusCopy__confirmed__ycHXs";
export const earned = "StatusCopy__earned__8OlXN";
export const expired = "StatusCopy__expired__3nkOa";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const pending = "StatusCopy__pending__u+7Ro";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const statusCopy = "StatusCopy__statusCopy__vSxFB";